import { useEffect, useRef, useState } from 'react'
import { useStore, useNavigate, usePathValidation } from '~hooks'
import * as Styled from './styled'
import SelfieRecognition, {
  SelfieCameraTypes,
  CallbackCamera,
  ErrorPictureResponse,
  SuccessPictureResponse,
  SelfieCameraType,
} from '~libs/imageRecognition'
import { getUrlEnvironment } from '~utils/path'
import Webcam from 'react-webcam'

function SelfieTake() {
  const [supportedBrowser, setSupportedBrowser] = useState(true)
  const [webcamOverlay, setWebcamOverlay] = useState(false)
  const isNotSmallScreen = !(window.screen.availWidth <= 768)
  const constraints = {
    audio: false,
    facingMode: 'user',
    width: null,
    height: null,
  }
  if (isNotSmallScreen) {
    constraints.width = 350
    constraints.height = 304
  }
  const webcamRef = useRef<Webcam>()
  const { update } = useStore()
  const navigate = useNavigate()
  const callbacks: CallbackCamera = {
    on: {
      success: function (response: SuccessPictureResponse) {
        update({ register: { selfie: response.base64 } })
        navigate('/cadastrar/selfie/confirmacao', { state: { previousPath: '/cadastrar/selfie/tirar' } })
      },
      error: function (error: ErrorPictureResponse) {
        if (error.code == 112) {
          setSupportedBrowser(false)
        }
      }
    },
  }

  function capturePhoto() {
    update({ register: { selfie: webcamRef.current.getScreenshot() } })
    navigate('/cadastrar/selfie/confirmacao', { state: { previousPath: '/cadastrar/selfie/tirar' } })
  }

  useEffect(() => {
    const environment = getUrlEnvironment()
    console.log('environment', environment)
    void openSelfieCamera(`/token_unico_${environment}.json`, SelfieCameraTypes.SMART)
  }, [])

  useEffect(() => {
    update({ register: { progress: 70 } })
  }, [update])

  usePathValidation([
    'cpf',
    'plate',
    'register.cellphone',
    'register.fullName',
    'register.rntrc',
  ])

  async function openSelfieCamera(
    jsonPath: string,
    cameraType: SelfieCameraType
  ) {
    const response = await SelfieRecognition.prepareSelfieCamera(
      jsonPath,
      cameraType
    )

    if (response) response.open(callbacks)
  }

  return (
    <>
      <Styled.Title>Se prepare para tirar sua foto</Styled.Title>
      {supportedBrowser ? (
        <Styled.Wrapper>
          <div id="box-camera"></div>
        </Styled.Wrapper>
      ) : <>
        <Styled.StandardCameraWrapper>
          {webcamOverlay && <Styled.Overlay />}
          <Styled.Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={constraints}
            onUserMedia={() => setWebcamOverlay(true)}
          />
        </Styled.StandardCameraWrapper>
        <Styled.Button type="button" width="100%" onClick={capturePhoto}>
          Tirar foto
        </Styled.Button>
      </>}
    </>
  )
}

export default SelfieTake
